import { render, staticRenderFns } from "./TrainSelectSeat.vue?vue&type=template&id=6864136a&scoped=true&"
import script from "./TrainSelectSeat.vue?vue&type=script&lang=js&"
export * from "./TrainSelectSeat.vue?vue&type=script&lang=js&"
import style0 from "./TrainSelectSeat.vue?vue&type=style&index=0&id=6864136a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864136a",
  null
  
)

export default component.exports